var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filters"},[(!_vm.options.filter.items.length)?_c('el-alert',{attrs:{"type":"warning","title":_vm.$t('This category has no filter options.'),"effect":"dark","closable":false}}):_vm._l((_vm.options.filter.items),function(filter){return _c('FilterValueInput',{key:filter.id,attrs:{"relatedFilter":filter}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }